import * as React from 'react';
import { Link } from '../../../common/Link';
import * as styles from './PublishTermsError.css';
import { IPublishTermsErrorProps } from './types';
import sadSmileIcon from '../../../../assets/sad-smile.png';

export const PublishTermsError = (props: IPublishTermsErrorProps) => {
  const { handleRetryClick } = props;

  return (
    <div className={styles['wrapper']}>
      <img src={sadSmileIcon} width={24} height={24} className={styles['icon']} />
      <span className={styles['message']}>
        Что-то пошло не так, <Link onClick={handleRetryClick}>повторите&nbsp;попытку</Link>
      </span>
    </div>
  );
};
